import { TicketTypeSerializer } from "@shared/modules/events/types/public";

export const getTicketTypes = (ticketTypes: TicketTypeSerializer[]) => {
  const now = new Date();

  return ticketTypes.filter((ticket) => {
    // Check if ticket is within sale timeframe
    const saleStartDate = ticket.sale_starts_on
      ? new Date(ticket.sale_starts_on)
      : null;
    const saleEndDate = ticket.sale_ends_on
      ? new Date(ticket.sale_ends_on)
      : null;
    const isOnSale =
      saleStartDate && saleEndDate && saleStartDate < now && saleEndDate > now;

    return (
      // Not sold out
      !ticket.sold_out &&
      // Not voucher purchases only
      !ticket.voucher_purchases_only &&
      // Is currently on sale
      isOnSale &&
      // Not password protected
      !ticket.is_password_protected &&
      // Not a custom package/bundle
      !(ticket.is_bundle && ticket.is_custom_package)
    );
  });
};
